import React, { Fragment } from "react";
import Header from "../subheader/Header";

import "./emails.scss";
import EmailCard from "./components/EmailCard";
import { CustomersEmails } from "../../../Extra/Emails";

const Emails = () => {
  const Data = CustomersEmails;

  return (
    <Fragment>
      <div className="vendor-page-right emails-page-desktop">
        <Header
          heading="Emails"
          search={false}
          filters={{ status: false, date_filter: false }}
        />
        <div className="right-content emails-page-right-content">
          <div className="content-container page-container">
            <div className="content-wrapper">
              <div className="emails-row d-flex flex-wrap">
                {Data.map((customerEmail) => {
                  return (
                    <div className="emails-card" key={customerEmail.id}>
                      <EmailCard email={customerEmail} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Emails;
